// Tela Limite. Sem partidas grátis hoje e sem bônus (item 69, canvas 1.4 e 1.4c): "Você já jogou suas 2 partidas grátis
// de hoje", com a hora em que voltam, a posição no ranking da semana, a vantagem principal de cada plano com ASSINAR
// direto para o Checkout e Chamar um amigo. Assistir continua liberado. Abre por toda saída da mesa e toda tentativa
// de jogar sem partidas, e na primeira abertura do dia no lugar do guia. Fechar leva à aba Jogar.
// Com partidas ou bônus guardado, a variante de antes (não bloqueia); para quem assina, "Seu plano não tem limite".
import { useEffect, useState } from 'react';
import { BONUS_POR_INDICACAO, PLANOS_PAGOS, NOME_DO_PLANO, VANTAGEM_PRINCIPAL, precoEmReais, type PlanoPago } from '@truco6/planos';
import type { RankingNaTela } from '@truco6/gamificacao';
import { imagemDaCarta } from '@truco6/ui';
import { lerRanking, type Eu } from '../comum/api.ts';
import type { PerfilConta, Sessao } from '../comum/conta.ts';
import { CartasDoDia, IconePresente } from '../comum/GuiaDoDia.tsx';
import { PONTOS_DA_VITORIA, lugarDoRanking, marcarGuiaVisto, situacaoNoRanking, tempoAteVoltar } from '../comum/guia-do-dia.ts';
import { avisoDoLimiteVisto, atualizarLimite, diariasRestantes, toqueEmAssinar, toqueEmIndique } from '../comum/limite.ts';
import { comPrazo } from '../comum/pote.ts';
import { ir, voltar } from '../comum/rotas.ts';
import { Rosto } from '../comum/Rosto.tsx';
import { abrirPlanosNoBronze } from '../comum/SeloGratis.tsx';
import { useAgora } from '../comum/useMesa.ts';
import { irParaCheckout, useEu } from './planos-comum.tsx';
import { Carregando, Tela } from './comum.tsx';

// O ranking que não responde em 3 s some da página.
export const ESPERA_DO_RANKING_MS = 3000;

export function Limite({ sessao, perfil }: { sessao: Sessao; perfil?: PerfilConta | null }) {
  const { eu, erro, carregar } = useEu(sessao);
  // O selo e o menu acompanham o que esta tela leu.
  useEffect(() => { if (eu) void atualizarLimite(); }, [eu]);
  if (!eu) {
    return erro ? (
      <Tela>
        <p className="erro" role="alert">{erro}</p>
        <button className="btn2 largo" onClick={() => void carregar()}>Tentar de novo</button>
      </Tela>
    ) : <Carregando />;
  }
  return eu.limite.restantes === 0 ? <SemPartidas sessao={sessao} perfil={perfil ?? null} eu={eu} /> : <ComPartidas sessao={sessao} eu={eu} />;
}

// Quem já assina (ou tem a cobrança desligada) vai para Planos, que mostra a troca; quem não assina vai direto ao Checkout.
const assinaDireto = (eu: Eu) => eu.plano === 'gratis' && eu.cobranca === 'ligada' && !eu.assinatura;

// ---------- sem partidas (canvas 1.4 e 1.4c) ----------
export function SemPartidas({ sessao, perfil, eu, ranking: rankingFixo }: {
  sessao: Sessao; perfil: PerfilConta | null; eu: Eu; ranking?: RankingNaTela | null;
}) {
  const l = eu.limite, total = l.limite ?? 2;
  const agora = useAgora(60_000);
  const [ocupado, setOcupado] = useState<PlanoPago | null>(null);
  const [falha, setFalha] = useState<string | null>(null);
  // undefined: lendo; null: não respondeu em 3 s (o cartão some).
  const [ranking, setRanking] = useState<RankingNaTela | null | undefined>(rankingFixo);
  useEffect(() => {
    avisoDoLimiteVisto('limite');
    // A página vale como o guia do dia: quem passou por ela não vê a folha de novo hoje.
    marcarGuiaVisto(sessao.id, Date.now());
  }, []);
  useEffect(() => {
    if (rankingFixo !== undefined) return;
    let vivo = true;
    const cidade = !!perfil?.cidadeIbge && !!perfil.rankingRegionalEm && !perfil.rankingRegionalDesligadoEm;
    void comPrazo(lerRanking(sessao, 'jogadores', cidade ? 'cidade' : 'brasil', 'semana'), ESPERA_DO_RANKING_MS).then((r) => { if (vivo) setRanking(r); });
    return () => { vivo = false; };
  }, [sessao.id]);

  async function assinar(plano: PlanoPago) {
    setFalha(null);
    toqueEmAssinar('limite');
    if (!assinaDireto(eu)) { ir({ tela: 'planos', plano, ciclo: 'mensal' }); return; }
    setOcupado(plano);
    try { await irParaCheckout(sessao, plano, 'mensal', 'limite'); } catch (e) { setFalha((e as Error).message); setOcupado(null); }
  }
  const relogio = (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
  );
  return (
    <Tela>
      <div className="duas-colunas limite-sem">
        <div className="col">
          <div className="topo-limite">
            <button className="fechar" aria-label="Fechar e voltar para a aba Jogar" onClick={() => ir({ tela: 'inicio' })}>×</button>
            <span className="chip-volta" role="timer">{relogio}{tempoAteVoltar(l.voltaEm, agora)}</span>
          </div>
          <div className="heroi-sem">
            <div className="cartas-e-rotulo">
              <CartasDoDia total={total} jogadas={total} rotulo={`Suas ${total} partidas grátis de hoje, as duas jogadas`} />
              <span className="rotulo-guia apagado">{total} DE {total}<br />JOGADAS HOJE</span>
            </div>
            <h1>Você já jogou suas {total} partidas grátis de hoje</h1>
            <p className="sub">Para seguir jogando agora, assine ou chame um amigo.</p>
          </div>
          {ranking && <CartaoRanking ranking={ranking} perfil={perfil} usuario={sessao.id} />}
          <button className="link assistir-enquanto" onClick={() => ir({ tela: 'inicio' })}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>
            Assistir uma sala enquanto isso
          </button>
        </div>
        <div className="col">
          <section className="escolha-plano" aria-labelledby="titulo-escolha">
            <div className="cab-escolha">
              <h2 id="titulo-escolha">ESCOLHA SEU PLANO</h2>
              <button className="link" onClick={() => ir({ tela: 'planos', plano: null, ciclo: 'mensal' })}>Comparar tudo</button>
            </div>
            <ul className="planos-limite">
              {PLANOS_PAGOS.map((p) => {
                const v = VANTAGEM_PRINCIPAL[p];
                return (
                  <li key={p} className={'plano-limite ' + p}>
                    <span className="nome-plano">{NOME_DO_PLANO[p].toUpperCase()}</span>
                    <span className="preco-plano">{precoEmReais(p)}<small>/mês</small></span>
                    <span className="heranca">{v.heranca}</span>
                    <b className="vantagem">{v.titulo}</b>
                    <span className="detalhe">{v.detalhe}</span>
                    <button className={p === 'bronze' ? 'btn1 assinar-plano' : 'btn2 dourado assinar-plano'} aria-label={`Assinar o ${NOME_DO_PLANO[p]}`}
                      disabled={ocupado !== null} onClick={() => void assinar(p)}>
                      {ocupado === p ? '...' : 'ASSINAR'}
                    </button>
                  </li>
                );
              })}
            </ul>
            {falha && <p className="erro" role="alert">{falha}</p>}
          </section>
          <section className="amigo-limite" aria-label="Chamar um amigo">
            <span className="ico-linha" aria-hidden="true"><IconePresente tamanho={22} /></span>
            <span className="texto-linha"><b>Chame um amigo</b><small>+{BONUS_POR_INDICACAO} partidas para você por amigo que criar conta</small></span>
            <button className="btn2 dourado" onClick={() => { toqueEmIndique('limite'); ir({ tela: 'indique' }); }}>CHAMAR</button>
          </section>
        </div>
      </div>
    </Tela>
  );
}

// O ranking da semana: a posição, os pontos e a distância para o top 10, com o top 3 à direita.
export function CartaoRanking({ ranking, perfil, usuario }: { ranking: RankingNaTela; perfil: PerfilConta | null; usuario: string }) {
  const s = situacaoNoRanking(ranking);
  const top3 = ranking.linhas.slice(0, 3);
  return (
    <section className="ranking-limite" aria-label="Seu ranking da semana">
      <div className="cab-ranking-limite">
        <span className="rotulo-guia apagado">RANKING DA SEMANA · {lugarDoRanking(ranking)}</span>
        {top3.length > 0 && (
          <span className="top3" aria-label={`Top 3: ${top3.map((x) => x.nome).join(', ')}`}>
            {top3.map((x, i) => <Rosto key={x.id} perfil={{ apelido: x.nome, avatar: x.avatar }} usuario={x.id} cor={i === 0 ? 'var(--gold-400)' : 'var(--gold-600)'} tamanho={26} />)}
          </span>
        )}
      </div>
      <div className="eu-ranking">
        <Rosto perfil={perfil ? { apelido: perfil.apelido, avatar: perfil.avatar } : null} usuario={usuario} cor="var(--gold-400)" tamanho={40} />
        <span className="texto-ranking">
          {s.tipo === 'sem_pontos'
            ? <><b>Você ainda não pontuou esta semana.</b><small>Cada vitória vale +{PONTOS_DA_VITORIA}.</small></>
            : <>
                <b>Você está em <em>{s.eu.posicao}º</em> · {s.eu.pontos} {s.eu.pontos === 1 ? 'ponto' : 'pontos'}</b>
                <small>{s.tipo === 'top10'
                  ? 'Você está no top 10. Quem assina defende o lugar jogando sem limite.'
                  : `Faltam ${s.faltam} ${s.faltam === 1 ? 'ponto' : 'pontos'} para o top 10: ${s.vitorias} ${s.vitorias === 1 ? 'vitória' : 'vitórias'}`}</small>
              </>}
        </span>
      </div>
      {s.tipo === 'fora' && (
        <div className="barra-ranking" aria-hidden="true"><i style={{ width: `${Math.min(100, Math.round((s.eu.pontos / Math.max(1, s.decimo)) * 100))}%` }} /></div>
      )}
    </section>
  );
}

// ---------- com partidas, com bônus ou sem limite (a variante de antes) ----------
function ComPartidas({ sessao, eu }: { sessao: Sessao; eu: Eu }) {
  const [ocupado, setOcupado] = useState(false);
  const [falha, setFalha] = useState<string | null>(null);
  const l = eu.limite, { restantes, bonus } = l;
  const trouxe = eu.indicacao?.entraram ?? [];
  const diarias = diariasRestantes(l);
  let titulo: string, sub: string;
  if (restantes === null) { titulo = 'Seu plano não tem limite'; sub = 'Jogue quantas partidas quiser, em qualquer mesa.'; }
  else if (diarias === 0) { titulo = `Você ainda tem ${bonus} ${bonus === 1 ? 'partida bônus' : 'partidas bônus'}`; sub = 'As grátis de hoje acabaram, e o bônus dos amigos vale agora. Para nunca mais contar:'; }
  else { titulo = `Você ainda tem ${restantes} ${restantes === 1 ? 'partida' : 'partidas'} hoje`; sub = `São ${l.limite} grátis por dia, em qualquer mesa, mais o bônus dos amigos que você chamar.`; }

  async function assinarBronze() {
    setFalha(null);
    toqueEmAssinar('limite');
    setOcupado(true);
    try { await irParaCheckout(sessao, 'bronze', 'mensal', 'limite'); } catch (e) { setFalha((e as Error).message); setOcupado(false); }
  }
  return (
    <Tela>
      <button className="fechar" aria-label="Fechar" onClick={voltar}>×</button>
      <div className="duas-colunas">
        <div className="col">
          <div className="heroi-limite">
            <div className="cartas-heroi" aria-hidden="true">
              {[-10, 10].map((r) => <img key={r} src={imagemDaCarta('verso')} alt="" style={{ transform: `rotate(${r}deg)` }} />)}
            </div>
            <h1>{titulo}</h1>
            <p className="sub">{sub}</p>
            {restantes !== null && bonus > 0 && diarias > 0 && <p className="ok">Bônus guardado: {bonus} {bonus === 1 ? 'partida' : 'partidas'}.</p>}
          </div>
        </div>
        <div className="col">
          {restantes !== null && (
            <>
              <section className="cartao opcao opcao-bronze" aria-label="Assinar o Bronze">
                <div className="opcao-cab"><span className="opcao-ico" aria-hidden="true">♾️</span>
                  <p><b>Assine o Bronze</b><span>{precoEmReais('bronze')} por mês, partidas ilimitadas em qualquer mesa.</span></p></div>
                <button className="btn1 largo" disabled={ocupado} onClick={() => (assinaDireto(eu) ? void assinarBronze() : (toqueEmAssinar('limite'), abrirPlanosNoBronze()))}>
                  {ocupado ? 'UM INSTANTE...' : 'ASSINAR BRONZE'}
                </button>
                {falha && <p className="erro" role="alert">{falha}</p>}
                <button className="link" onClick={() => ir({ tela: 'planos', plano: null, ciclo: 'mensal' })}>
                  Ver todos os planos <small>a partir de {precoEmReais('bronze')}/mês</small>
                </button>
              </section>
              <section className="cartao opcao" aria-label="Chamar um amigo">
                <div className="opcao-cab"><span className="opcao-ico" aria-hidden="true">🎁</span>
                  <p><b>Chame um amigo</b><span>Cada amigo novo que criar conta vale +{BONUS_POR_INDICACAO} partidas para você, sem prazo.</span></p></div>
                <div className="opcao-pe">
                  {trouxe.length > 0 && (
                    <span className="trouxe">
                      <span className="rostos">{trouxe.slice(0, 3).map((p, i) => <Rosto key={i} perfil={p} cor="var(--gold-400)" tamanho={36} />)}</span>
                      Você já trouxe <b>{trouxe.length}</b>
                    </span>
                  )}
                  <button className="btn2 dourado" onClick={() => { toqueEmIndique('limite'); ir({ tela: 'indique' }); }}>CHAMAR AMIGO</button>
                </div>
              </section>
            </>
          )}
          <div className="rodape-cta">
            <button className={restantes === null ? 'btn1 largo' : 'btn2 largo'} onClick={() => ir({ tela: 'inicio' })}>JOGAR</button>
          </div>
        </div>
      </div>
    </Tela>
  );
}
